// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../../types";

import gql from "graphql-tag";
export type AttachmentsProposalFragment = {
  __typename?: "Proposal";
  documents?: Array<{
    __typename?: "ProposalDocument";
    filename: string;
    URL: string;
  }> | null;
};

export const AttachmentsProposalFragmentDoc = gql`
  fragment AttachmentsProposal on Proposal {
    documents {
      filename
      URL
    }
  }
`;
